import { render, staticRenderFns } from "./point_out.vue?vue&type=template&id=589360f6&scoped=true&"
import script from "./point_out.vue?vue&type=script&lang=js&"
export * from "./point_out.vue?vue&type=script&lang=js&"
import style0 from "./point_out.vue?vue&type=style&index=0&id=589360f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589360f6",
  null
  
)

export default component.exports